"use client"

import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import { GripVertical } from "lucide-react"
import { DropdownMenuCheckboxItem } from "@/components/ui/dropdown-menu"
import { useShellTranslation } from "@/lib/shell/use-shell-translation"

interface SortableFilterItemProps {
  filterId: string
  displayName: string
  checked: boolean
  onCheckedChange: (value: boolean) => void
}

export function SortableFilterItem({
  filterId,
  displayName,
  checked,
  onCheckedChange,
}: SortableFilterItemProps) {
  const { t } = useShellTranslation()
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: filterId, attributes: { roleDescription: t("shell.table.drag.roleDescription") } })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="flex items-center justify-between px-2 py-1 hover:bg-accent rounded-sm"
    >
      <DropdownMenuCheckboxItem
        className="capitalize flex-1 focus:bg-transparent"
        checked={checked}
        onCheckedChange={onCheckedChange}
        onSelect={(e) => e.preventDefault()}
      >
        {displayName}
      </DropdownMenuCheckboxItem>
      <div
        {...attributes}
        {...listeners}
        className="cursor-grab active:cursor-grabbing p-1 hover:bg-muted rounded"
      >
        <GripVertical className="h-4 w-4 text-muted-foreground" />
      </div>
    </div>
  )
}
